<script setup lang="ts">
import { computed } from 'vue'
import { useRoute } from 'vue-router'

import { Breadcrumb, BreadcrumbItem, BreadcrumbLink, BreadcrumbList, BreadcrumbPage, BreadcrumbSeparator } from '@/ui'

const route = useRoute()

const breadcrumbs = computed(() =>
  route.matched
    .filter(routeItem => routeItem.meta.breadcrumb)
    .map(routeItem => {
      return {
        name: routeItem.meta.breadcrumb,
        to: routeItem.path,
      }
    })
)
</script>

<template>
  <Breadcrumb>
    <BreadcrumbList>
      <template v-for="(breadcrumb, index) in breadcrumbs" :key="breadcrumb.name">
        <BreadcrumbItem v-if="index < breadcrumbs.length - 1" class="cursor-pointer">
          <BreadcrumbLink :to="breadcrumb.to">{{ breadcrumb.name }}</BreadcrumbLink>
        </BreadcrumbItem>
        <BreadcrumbSeparator v-if="index < breadcrumbs.length - 1" />
        <BreadcrumbItem v-if="index === breadcrumbs.length - 1">
          <BreadcrumbPage>{{ breadcrumb.name }}</BreadcrumbPage>
        </BreadcrumbItem>
      </template>
    </BreadcrumbList>
  </Breadcrumb>
</template>
